import React from 'react'
import {AiOutlineArrowRight} from 'react-icons/ai'

const Workitem = ({work}) => {
  return (
    <div className='project'>
        <img className='projectImage' src={work.image} alt="" />
        <h4 className='projectTitle'>{work.title}</h4>
        <a className='projectLink' href={work.url} target='_blank'>Demo <AiOutlineArrowRight className='proIcon'/> </a>
    </div>
  )
}

export default Workitem
